/**
 * @desc test2
 */
const URL = "/rantion-mail";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/mail/mailAccount/test2`, {
      method: "POST",

      ...options,
    }),
  );
}
